export default __webpack_public_path__ + "static/media/7000BLEU.6360f3c5.pdf";